import { render, staticRenderFns } from "./adjustDialog.vue?vue&type=template&id=b584869a&scoped=true"
import script from "./adjustDialog.vue?vue&type=script&lang=js"
export * from "./adjustDialog.vue?vue&type=script&lang=js"
import style0 from "./adjustDialog.vue?vue&type=style&index=0&id=b584869a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b584869a",
  null
  
)

export default component.exports